class ProductMedia extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['thumbnails', 'thumbnail', 'medias', 'media']
  }

  setupListeners () {
    super.setupListeners()

    this.onThumbnailClick = this.onThumbnailClick.bind(this)

    this.listeners.add(
      this.els.thumbnails.element,
      'click',
      this.onThumbnailClick,
    )

    this.observeItems()
  }

  onThumbnailClick (event) {
    const thumbnail = event.target.closest(this.els.thumbnail.selector)
    if (!thumbnail) return

    const media = this.els.media.elements.find(
      el => thumbnail.dataset.thumbnail === el.dataset.index,
    )
    if (!media) return

    window.BAO.Utils.scrollToY(
      window.BAO.Utils.getOffsetTop(media) - this.anchorOffset,
    )
  }

  observeItems () {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 1,
    }

    function observerCallback (entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const thumbnailItem = Array.from(
            document.querySelectorAll(
              '.prd-Media [data-product-media-el="thumbnail"]',
            ),
          ).find(el => el.dataset.thumbnail === entry.target.dataset.index)

          thumbnailItem.setAttribute('aria-current', true)
          document
            .querySelectorAll('.prd-Media [data-product-media-el="thumbnail"]')
            .forEach(item => {
              if (item !== thumbnailItem) {
                item.setAttribute('aria-current', false)
              }
            })
        }
      })
    }

    // eslint-disable-next-line compat/compat
    const observer = new IntersectionObserver(observerCallback, observerOptions)

    this.els.media.elements.forEach(media => observer.observe(media))
  }

  get anchorOffset () {
    const announcementHeight =
      document.querySelector('.hd-AnnouncementBar')?.offsetHeight ?? 0
    const headerHeight =
      document.querySelector('[data-section-type="header"]')?.offsetHeight ?? 0

    return announcementHeight + headerHeight
  }
}

if (!customElements.get('product-media')) {
  customElements.define('product-media', ProductMedia)
}
